import { getEndPoint } from './getEndPoint'
export const getEducationArticles = () =>
  Promise.all([
    getEndPoint('wp/v2/health-education?page=1&per_page=100'),
    getEndPoint('wp/v2/health-education?page=2&per_page=100'),
  ])
    .then(([page1, page2]) => {
      return [...page1, ...page2]
    })
    .catch(() => [])
